import styled from '@emotion/styled'

import {cssTheme} from '../../../themes'

export const StyledPopper = styled.div<{isVisible: boolean}>`
  border-radius: ${cssTheme.layout.radius.lg};
  background-color: ${cssTheme.colors.background.neutral.primary};
  box-shadow: ${cssTheme.shadows.floating};
  z-index: 4;
  overflow: hidden;
  opacity: ${({isVisible}) => (isVisible ? 1 : 0)};
`
